import React, { useState, useEffect, useRef } from 'react'

import {
  Modal, Button
} from 'react-bootstrap';

import _ from 'lodash';
import cx from 'classnames';

import styles from './componentStyles.module.scss'

export const ModalHeader = ({ headerName, onClose, type, onAddAssets }) => {

  return (
    <Modal.Header className={styles.header}>
      <div className={styles.modalDetails}>
        <div className={styles.title}>
          {headerName}
        </div>
        <div className={cx(styles.typeLabel, {[styles.higlight]: type === 'dynamic'})}>{type}</div>
        {/* <div className={styles.gatingSection}>
        <span className={styles.label}>Section Gating</span>
        <Button variant='info'><i className={cx(styles.lockIcon, 'cleverstory-unlock')} /></Button>
      </div> */}
      </div>
      <div className={styles.actions}>
        {type == 'manual' &&
          <Button
            className={cx(styles.actionButton)}
            variant="primary"
            type="submit"
            onClick={onAddAssets}
          >
            <i className={cx(styles.icon, 'cleverstory-plus')} />
            Add Content
          </Button>
        }
        <Button variant='info' onClick={onClose} className={cx(styles.closeButton)}>
          <i className={cx("cleverstory-close")} />
        </Button>
      </div>
    </Modal.Header>
  )
}

export const Footer = ({ type, filtered, onSave, selected, updating }) => {

  return (
    <div className={styles.footer}>
      {type === 'dynamic' ?
      <span className={cx(styles.selectedLabel, {[styles.show]: selected > -1})}>Filtered: {filtered}</span>  
      :
      <span className={cx(styles.selectedLabel, {[styles.show]: selected > -1})}>Selected: {selected}</span>}  
      <Button size="sm" onClick={onSave} className={styles.saveButton} variant="primary" >
        {updating ? `Saving` : `Save & Close`}
      </Button>
    </div>
  )
}

export const getFieldSelector = (mapping, key) => {
  const fields = _.get(mapping, 'fields') || [];
  const field = fields.find(item => item.name === key);

  return field;
}

export const getContentForFieldSelector = (mapping, key) => {
  const field = getFieldSelector(mapping, key);

  if (!field) {
    return null;
  }

  return _.get(field, `content`);
}
